import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { useEffect, useState } from 'react';
// import 'react-data-grid/lib/styles.css';
import LoadingButton from '@mui/lab/LoadingButton';
import Backdrop from '@mui/material/Backdrop';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import RotateLoader from 'react-spinners/RotateLoader';
import numToWell from '../Reusable/numToWell';
import { MyCell } from './MyCell';

const columnsSample = [
  {
    field: 'well',
    headerName: 'Well',
    width: 20,
    valueGetter: (params) => {
      return numToWell(params.row.well);
    },
  },
  { field: 'name', headerName: 'Sample Name', width: 300 },
  {
    field: 'primer',
    headerName: 'Primer',
    width: 300,
    renderCell: (params) => {
      if (params.row.primer == undefined) {
        return 'premixed';
      }
      const items = params.row.primer.name.split(',|');
      return (
        <div>
          {items.map((item, index) => (
            <div key={index}>{item.trim()}</div>
          ))}
        </div>
      );
      // return params.row.primer.name;
    },
  },
  { field: 'concentration', headerName: 'Concentration', width: 120 },
  { field: 'readLength', headerName: 'Read Length', width: 120 },
  { field: 'volume', headerName: 'Volume', width: 100 },
  { field: 'sangerType', headerName: 'Type', width: 100 },
  { field: 'sangerTemplate', headerName: 'Desired Template', width: 200 },
];

const columnsPrimer = [
  { field: 'name', headerName: 'Primer Name', width: 500 },
  { field: 'volume', headerName: 'Volume', width: 150 },
];
const columnsFragment = [
  {
    field: 'well',
    headerName: 'Well',
    valueGetter: (params) => {
      return numToWell(params.row.well);
    },
  },
  { field: 'name', headerName: 'Sample Name', width: 250 },
  { field: 'fragmentType', headerName: 'Sample Type', width: 200 },
  { field: 'sizeStandard', headerName: 'Size standard', width: 200 },
  { field: 'fragmentDyeSet', headerName: 'Dye Set', width: 200 },
  { field: 'runModule', headerName: 'Run Module', width: 200 },
];

const API_ENDPOINT =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_ENDPOINT_PROD
    : process.env.REACT_APP_API_ENDPOINT_DEV;

const SampleListView = (props) => {
  const [open, openchange] = useState(false);
  const orderCode = props.orderCode;
  const dropOffCode = props.dropOffCode;
  const buttonTitle = props.buttonTitle ?? 'View Samples';
  const tite = props.title ?? 'Sample Data';
  const mergeSameWellNumber = props.mergeSameWellNumber ?? false;

  const [sampleData, setSampleData] = useState([]); // all the data is here
  const [primerData, setPrimerData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [orderType, setOrderType] = useState('sanger');

  const { enqueueSnackbar } = useSnackbar();
  const [selectFunctionLoading, setSelectFunctionLoading] = useState(false);
  const selectFunction = props.selectFunction ?? false;
  const selectKey = props.selectKey;
  const checkbox = selectFunction ? true : false;

  const handleSelectionModelChange = (newSelectionModel) => {
    const selectedData = sampleData.filter((row) =>
      newSelectionModel.includes(row.id)
    );
    setSelectedRows(selectedData);
  };

  const handleButtonClick = async () => {
    if (selectFunction) {
      setSelectFunctionLoading(true);
      try {
        await selectFunction(selectedRows);
        enqueueSnackbar('Operation successful!', { variant: 'success' });
      } catch (error) {
        console.error('Error executing selectFunction:', error);
        enqueueSnackbar('An error occurred. Please try again.', {
          variant: 'error',
        });
      } finally {
        setSelectFunctionLoading(false);
      }
    }
  };

  const functionopenpopup = () => {
    openchange(true);
  };
  const closepopup = () => {
    openchange(false);
  };

  async function doSetSelectedRows(sampleDataInput) {
    if (selectKey) {
      var newSelectedRows = sampleDataInput.filter(
        (row) => row[selectKey] == true
      );
      setSelectedRows(newSelectedRows);
    }
  }

  async function getSangerData() {
    setIsLoading(true);
    setSelectedRows([]);
    const res = await axios({
      method: 'get',
      url: API_ENDPOINT + '/order/samples',
      params: {
        orderCode: orderCode,
        dropOffCode: dropOffCode,
      },
    });
    if (res.status == 200) {
      let resSampleData = await addIncrementalId(res.data.samples);

      let indexesToBeDeleted = [];
      let left = 0;
      if (mergeSameWellNumber) {
        for (let right = 1; right < resSampleData.length; right++) {
          if (
            resSampleData[left].primer &&
            resSampleData[right].primer &&
            resSampleData[left].well == resSampleData[right].well
          ) {
            resSampleData[left].primer.name +=
              ',|' + resSampleData[right].primer.name;
            indexesToBeDeleted.push(right);
          } else {
            left = right;
          }
        }
        let updatedResSampleData = resSampleData.filter(
          (_, index) => !indexesToBeDeleted.includes(index)
        );
        setSampleData(updatedResSampleData);
        doSetSelectedRows(updatedResSampleData);
        setPrimerData(res.data.primers);
        setOrderType(res.data.orderType);
        setIsLoading(false);
      } else {
        setSampleData(resSampleData);
        doSetSelectedRows(resSampleData);
        setPrimerData(res.data.primers);
        setOrderType(res.data.orderType);
        setIsLoading(false);
      }
    }
  }
  useEffect(() => {
    if (open == true) {
      getSangerData();
    }
  }, [open]);

  async function addIncrementalId(data) {
    return data.map((item, index) => ({
      ...item,
      id: index,
    }));
  }
  return (
    <div style={{ textAlign: 'center' }}>
      <Button onClick={functionopenpopup} color="primary" variant="contained">
        {buttonTitle}
      </Button>
      <Dialog open={open} onClose={closepopup} fullWidth maxWidth="xl">
        <Backdrop sx={{ color: '#fff', zIndex: 3 }} open={isLoading}>
          <RotateLoader />
        </Backdrop>
        <DialogTitle>
          {orderCode} {tite}
          <IconButton onClick={closepopup} style={{ float: 'right' }}>
            <CloseIcon color="primary"></CloseIcon>
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ flexGrow: 1 }}>
          <DataGrid
            style={{ height: 500 }}
            checkboxSelection={checkbox}
            rows={sampleData}
            columns={orderType == 'sanger' ? columnsSample : columnsFragment}
            pageSize={96}
            selectionModel={selectedRows.map((row) => row.id)}
            onSelectionModelChange={handleSelectionModelChange}
          />
          {selectFunction && (
            <div style={{ textAlign: 'center' }}>
              <LoadingButton
                size="large"
                // classes="profileSubmit"
                // type="submit"
                variant="outlined"
                onClick={handleButtonClick}
                disabled={isLoading || selectFunctionLoading}
                loading={selectFunctionLoading}
                loadingIndicator={
                  <RotateLoader
                    cssOverride={{ left: '100%' }}
                    size={7}
                    margin={-15}
                  />
                }
              >
                Submit
              </LoadingButton>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default SampleListView;
